export const LEFT_MENU_SHOW = "LEFT_MENU_SHOW";
export const LEFT_MENU_HIDE = "LEFT_MENU_HIDE";

export function leftMenuShow() {
  return dispatch => {
    dispatch({ type: LEFT_MENU_SHOW });
  }
}

export function leftMenuHide() {
  return dispatch => {
    dispatch({ type: LEFT_MENU_HIDE });
  }
}